function isDesktopApp() {
    return Boolean(window === null || window === void 0 ? void 0 : window.electronPreload);
}

export { isDesktopApp };
